var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSegmentIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3629 8.79272C14.6064 9.03622 14.6064 9.43192 14.3629 9.64498L9.64498 14.3629C9.40148 14.6064 9.00578 14.6064 8.79272 14.3629L2.40074 7.97089C2.15723 7.72739 1.94417 7.27082 1.91373 6.936L1.45716 2.00504C1.42672 1.67022 1.67022 1.42672 2.00504 1.45716L6.936 1.91373C7.27082 1.94417 7.72739 2.15723 7.97089 2.40074L14.3629 8.79272Z",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85263 5.87112C6.31621 5.40754 6.31621 4.65593 5.85263 4.19235C5.38905 3.72877 4.63744 3.72877 4.17386 4.19235C3.71028 4.65593 3.71028 5.40754 4.17386 5.87112C4.63744 6.3347 5.38905 6.3347 5.85263 5.87112Z",
    stroke: "#252525",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentIconActive);
export default __webpack_public_path__ + "static/media/segment-icon-active.39b9cfd7a2df860c4b335a1f8e7e3b7c.svg";
export { ForwardRef as ReactComponent };